import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=3a34e66e&scoped=true"
import script from "./OffersView.vue?vue&type=script&lang=js"
export * from "./OffersView.vue?vue&type=script&lang=js"
import style0 from "./OffersView.vue?vue&type=style&index=0&id=3a34e66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a34e66e",
  null
  
)

export default component.exports